import { Component, Input, AfterContentInit } from '@angular/core';

@Component({
  selector: 'zoom-footer',
  templateUrl: './zoom-footer.component.html',
  styleUrls: ['./zoom-footer.component.scss']
})
export class ZoomFooterComponent implements AfterContentInit {
   @Input() raetId: string;

    ngAfterContentInit() {
        this.isValid();
    }

    isValid() {
        if (!this.raetId) {
            console.error('component is not correctly binding, raet id missing');
        }
    }
}
